import { gqlClient } from '../../components/AppProvider';
import { UpdateTenantAccountSettingsInput } from '../../gql-types.generated';
import { queryTenantAccountById } from '../../gql/QueryTenantAccountById';
import { mutationUpdateTenantAccountSettings } from '../../gql/MutationUpdateTenantAccountSettings';
import { AppThunk } from '../../store';
import { decrementRequestsInFlight, incrementRequestsInFlight } from '../app/AppSlice';
import {
  fetchTenantStart,
  fetchTenantSuccess,
  fetchTenantError,
  updateTenantStart,
  updateTenantSuccess,
  updateTenantError,
} from './TenantSettingsSlice';

export const fetchTenantById =
  (tenantId: string): AppThunk =>
  async dispatch => {
    dispatch(incrementRequestsInFlight());
    dispatch(fetchTenantStart());
    try {
      const result = await queryTenantAccountById(gqlClient, tenantId);
      if (result) dispatch(fetchTenantSuccess(result));
      dispatch(decrementRequestsInFlight());
    } catch (e) {
      dispatch(fetchTenantError(e as Error));
      dispatch(decrementRequestsInFlight());
    }
  };

export const updateTenantSettings =
  (tenantId: string, input: UpdateTenantAccountSettingsInput): AppThunk =>
  async dispatch => {
    dispatch(incrementRequestsInFlight());
    dispatch(updateTenantStart());
    try {
      await mutationUpdateTenantAccountSettings(gqlClient, tenantId, input);
      dispatch(updateTenantSuccess());
      dispatch(fetchTenantById(tenantId));
      dispatch(decrementRequestsInFlight());
    } catch (e) {
      dispatch(updateTenantError(e as Error));
      dispatch(decrementRequestsInFlight());
    }
  };
